/*
 * Adelanto NEX — Redux action types & creators.
 *
 * FR-NEW-02: Front-end chain for "Enviar NEX" (V2 doc §13):
 *   PUT /api/volumen/adelanto/iniciarpago/
 *   → sign transactionDetails
 *   → PUT /api/volumen/adelanto/broadcastpago/
 */

export const SEND_ADELANTO = 'SEND_ADELANTO';
export const SEND_ADELANTO_RESPONSE = 'SEND_ADELANTO_RESPONSE';
export const SEND_ADELANTO_ERROR = 'SEND_ADELANTO_ERROR';
export const RESET_SEND_ADELANTO = 'RESET_SEND_ADELANTO';

export default {
    /*
     * `contractId` is optional; when present, the adelanto middleware will
     * dispatch `contract.getContract(contractId)` on successful send so
     * the UI sees the freshly updated `adelanto_status` (demo-finding #5
     * — without it the badge stays clickable and the user can re-send).
     */
    sendAdelanto: ({ versionId, contractId, producto, observacion, successCallback }) => ({
        type: SEND_ADELANTO,
        versionId,
        contractId,
        producto,
        observacion,
        successCallback,
    }),
    sendAdelantoResponse: (response) => ({ type: SEND_ADELANTO_RESPONSE, response }),
    sendAdelantoError: (error) => ({ type: SEND_ADELANTO_ERROR, error }),
    resetSendAdelanto: () => ({ type: RESET_SEND_ADELANTO }),
};
